export const api = {
  // Use REACT_APP_API_URL when provided, otherwise default to the local
  // backend that is published on host port 8000 by the running Docker
  // backend container (0.0.0.0:8000 -> container:80).
  hostname: process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000',
};
